import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { genericColor } from "~/lib/resolvers";
const Wrapper = styled.div`
  display: flex;
  flex-wrap: ${_ref => {
  let {
    $wrap
  } = _ref;
  return $wrap;
}};
  gap: ${_ref2 => {
  let {
    $gap,
    theme
  } = _ref2;
  return $gap * theme.typography.fontStep;
}}rem;
  ${_ref3 => {
  let {
    $rounded,
    theme
  } = _ref3;
  return $rounded && `border-radius: ${theme.shape.borderRadius.primary}`;
}};
  background-color: ${_ref4 => {
  let {
    theme,
    $color
  } = _ref4;
  return genericColor(theme, $color);
}};
  align-items: ${_ref5 => {
  let {
    $align
  } = _ref5;
  return $align;
}};
  justify-items: ${_ref6 => {
  let {
    $justify
  } = _ref6;
  return $justify;
}};
  justify-content: ${_ref7 => {
  let {
    $justify
  } = _ref7;
  return $justify;
}};
  flex-direction: ${_ref8 => {
  let {
    $direction
  } = _ref8;
  return $direction;
}};
  ${_ref9 => {
  let {
    $fullWidth
  } = _ref9;
  return $fullWidth && "width: 100%";
}};
  ${_ref10 => {
  let {
    $fullHeight
  } = _ref10;
  return $fullHeight && "height: 100%";
}};
  ${_ref11 => {
  let {
    $s,
    theme
  } = _ref11;
  return theme.spacing.resolve(theme, $s);
}};
`;
const Box = _ref12 => {
  let {
    gap = 0,
    align = "start",
    color = "transparent",
    justify = "start",
    fullWidth = false,
    fullHeight = false,
    rounded = false,
    direction = "row",
    wrap = "wrap",
    children,
    s,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $gap: gap,
    $color: color,
    $align: align,
    $justify: justify,
    $wrap: wrap,
    $fullWidth: fullWidth,
    $fullHeight: fullHeight,
    $direction: direction,
    $rounded: rounded,
    $s: s
  }, rest), children);
};
export default Box;